
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import GoogleLogin from 'react-google-login';
import axios from "axios";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
    Button,
    TextField,
    Typography, IconButton, InputAdornment, Dialog, DialogContent, Box,CircularProgress
} from "@mui/material";

import "../../styles/App.css";
import logo from '../../styles/logo.png';

function Login() {
	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});
	const [showPassword, setShowPassword] = useState(false);
	const loginApiUrl = process.env.REACT_APP_LOGIN_API;
	const google_FB_GIT_loginApiUrl = process.env.REACT_APP__SOCIAL_LOGIN_API;  
	const [responseMessage, setResponseMessage] = useState("");
	const navigate = useNavigate();
	const [openDialog, setOpenDialog] = useState(false); 
	const [dialogMessage, setDialogMessage] = useState(""); 
  const [loading, setLoading] = useState(false);




  const mfaVerifyApiUrl = process.env.REACT_APP_MFA_VERIFY_API;

const [mfaOpen, setMfaOpen] = useState(false);
const [mfaToken, setMfaToken] = useState("");
const [mfaCode, setMfaCode] = useState("");
const [mfaError, setMfaError] = useState("");
const [mfaLoading, setMfaLoading] = useState(false);
const [useBackupCode, setUseBackupCode] = useState(false);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleSignup = () => {
		navigate("/register");
	};

	const reset = () => {
		navigate("/ResetPasswordForm");
	};



	const handleNavigation = async (email) => {
	try {
		// Send email to backend for verification
		const backendResponse = await axios.post(google_FB_GIT_loginApiUrl, { email });

		if (backendResponse.data.success) {
			const userType = backendResponse.data.userType;

			// Redirect based on the user type
			switch (userType) {
				case "recruiter":
					navigate("/recruiter-dashboard");
					break;

				case "interviewer":
					navigate("/interviewer-dashboard");
					break;

				case "hiringManager":
					navigate("/hiring-dashboard");
					break;

				case "admin":
					navigate("/admin-dashboard");
					break;
				case "humanResource":
					navigate("/hr-dashboard");
					break;

				default:
					console.log("Invalid user type.");
			}
		} else {
			console.log("Email not found in the database.");
			setResponseMessage("Email not found in the database.");
		}
	} catch (error) {
		console.error("Error:", error);
	}
};


const submitMfaCode = async (e) => {
    e?.preventDefault();
    const code = mfaCode.trim();
    if (!code) return;

    setMfaLoading(true);
    setMfaError("");

    try {
        const response = await fetch(mfaVerifyApiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ mfaToken, code }),
        });

        const data = await response.json();

        if (response.ok) {
            setMfaOpen(false);
            setMfaToken("");
            setMfaCode("");
            completeLogin(data);
        } else {
            setMfaCode("");
            if (response.status === 401 && /expired|sign in again/i.test(data.message || "")) {
                setMfaOpen(false);
                setMfaToken("");
                handleDialog("Your verification window expired. Please sign in again.");
            } else {
                setMfaError(data.message || "Invalid code.");
            }
        }
    } catch (error) {
        console.error("Error:", error);
        setMfaError("Connection problem. Please try again.");
    } finally {
        setMfaLoading(false);
    }
};

const closeMfa = () => {
    setMfaOpen(false);
    setMfaToken("");
    setMfaCode("");
    setMfaError("");
};

const completeLogin = (data) => {
    const { userType, name, phone, email, _id: userId } = data.user;
    const token = data.token;
    const jds = data.jds;

    localStorage.setItem('email', email);
    localStorage.setItem('token', token);
    // Persist the user profile so dashboards survive a refresh (location.state is lost on F5).
    localStorage.setItem('rbotUser', JSON.stringify({ email, name, phone, userType, _id: userId }));
    saveToken(email, token);

    const baseState = { email, name, phone, userType, _id: userId };

    switch (userType) {
        case "recruiter":
            navigate("/recruiter-dashboard", {
                state: { ...baseState, jds, initialScreeningIds: data.screeningIDs },
            });
            break;

        case "interviewer":
            navigate("/interviewer-dashboard", { state: { ...baseState, jds } });
            break;

        case "hiringManager":
            navigate("/hiring-dashboard", { state: { ...baseState, jds } });
            break;

        case "admin":
            navigate("/admin-dashboard", {
                state: {
                    ...baseState,
                    initialPendingUsers: data.pendingUsers,
                    initialApprovedUsers: data.approvedUsers,
                    initialRejectedUsers: data.rejectedUsers,
                },
            });
            break;

        case "humanResource":
            navigate("/hr-dashboard", { state: baseState });
            break;

        case "manager":
            navigate("/manager/dashboard", { state: baseState });
            break;

        default:
            handleDialog("Invalid user type.");
    }
};



const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        const response = await fetch(loginApiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
        });

        if (response.ok) {
            const data = await response.json();
            console.log("login response:", data);

            if (data.mfaSetupRequired) {
                navigate("/mfa-setup", { state: { setupToken: data.setupToken } });
                return;
            }

            if (data.mfaRequired) {
                setMfaToken(data.mfaToken);
                setMfaCode("");
                setMfaError("");
                setUseBackupCode(false);
                setMfaOpen(true);
                return;
            }

            completeLogin(data);
        } else {
            const rawText = await response.text();
            let errorMessage = rawText;
            try {
                const parsed = JSON.parse(rawText);
                errorMessage = parsed.message || rawText;
            } catch {}
            handleDialog(errorMessage);
        }
    } catch (error) {
        console.error("Error:", error);
        handleDialog("Something went wrong. Please check your connection and try again.");
    } finally {
        setLoading(false);
    }
};

    const responseGoogle = async (response) => {
        try {
            if (response?.profileObj?.email) await handleNavigation(response.profileObj.email);
        } catch (error) { console.error("Error:", error); }
    };

    const onFailure = (error) => { console.log("Sign-In failed:", error); }; 
    const saveToken = (email, token) => {
        const tokens = JSON.parse(localStorage.getItem('userTokens')) || {};
        tokens[email] = token; 
        localStorage.setItem('userTokens', JSON.stringify(tokens));
    };  

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     try {
    //         const response = await fetch(loginApiUrl, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify(formData),
    //         });
    //         if (response.ok) {
    //             const data = await response.json();
    //             localStorage.setItem('email', data.user.email);
    //             localStorage.setItem('token', data.token);
    //             saveToken(data.user.email, data.token);
                
    //             // Original Switch Logic
    //             switch (data.user.userType) {
    //                 case "recruiter": navigate("/recruiter-dashboard", { state: { jds: data.jds, email: data.user.email, name: data.user.name, phone: data.user.phone, userType: data.user.userType, initialScreeningIds: data.screeningIDs } }); break;
    //                 case "interviewer": navigate("/interviewer-dashboard", { state: { email: data.user.email, name: data.user.name, phone: data.user.phone, jds: data.jds, userType: data.user.userType } }); break;
    //                 case "hiringManager": navigate("/hiring-dashboard", { state: { email: data.user.email, name: data.user.name, phone: data.user.phone, jds: data.jds, userType: data.user.userType } }); break;
    //                 case "admin": navigate("/admin-dashboard", { state: { email: data.user.email, name: data.user.name, phone: data.user.phone, userType: data.user.userType, initialPendingUsers: data.pendingUsers, initialApprovedUsers: data.approvedUsers, initialRejectedUsers: data.rejectedUsers } }); break;
    //                 default: handleDialog("Invalid user type.");
    //             }
    //         } else {
    //             handleDialog(await response.text());
    //         }
    //     } catch (error) { handleDialog("Error: " + error.message); }
    // };

    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    const handleDialog = (msg) => { setDialogMessage(msg); setOpenDialog(true); };
    const handleCloseDialog = () => setOpenDialog(false);

    return (
        <Box sx={{ display: "flex", height: "100vh", overflow: "hidden", backgroundColor: "#0f0c29" }}>
            <style>
                {`
                @keyframes meshGradient {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }
                @keyframes floatCard {
                    0%, 100% { transform: translateY(0) rotate(0deg); }
                    50% { transform: translateY(-10px) rotate(0.5deg); }
                }
                @keyframes contentEntrance {
                    from { opacity: 0; transform: scale(0.9) translateY(20px); }
                    to { opacity: 1; transform: scale(1) translateY(0); }
                }
                .mesh-bg {
                    background: linear-gradient(-45deg, #240b36, #4f378b, #0f0c29, #2b1055);
                    background-size: 400% 400%;
                    animation: meshGradient 12s ease infinite;
                }
                .glass-panel {
                    background: rgba(255, 255, 255, 0.03);
                    backdrop-filter: blur(15px);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 30px;
                    padding: 40px;
                    animation: floatCard 6s ease-in-out infinite;
                }
                .entrance-delay {
                    animation: contentEntrance 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
                }
                `}
            </style>

            {/* Left Section: Unique Animated Branding */}
            <Box className="mesh-bg" sx={{ flex: 1.2, display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                <Box className="entrance-delay" sx={{ textAlign: 'center', zIndex: 2, p: 4 }}>
                    <Box component="img" src={logo} sx={{ width: 180, mb: 3, filter: 'drop-shadow(0 0 20px rgba(255,255,255,0.3))' }} />
                    <Typography variant="h1" sx={{ fontFamily: 'Righteous', fontSize: '4rem', color: '#fff', mb: 2, textShadow: '0 10px 20px rgba(0,0,0,0.3)' }}>
                        Resourcing-Bot
                    </Typography>
                    <Typography variant="h5" sx={{ color: 'rgba(255,255,255,0.7)', fontWeight: 300, letterSpacing: 1.5 }}>
                        The Future of Effortless Hiring
                    </Typography>
                </Box>
                {/* Decorative Blobs */}
                <Box sx={{ position: 'absolute', width: '300px', height: '300px', background: 'rgba(79, 55, 139, 0.4)', borderRadius: '50%', filter: 'blur(80px)', top: '10%', left: '10%' }} />
                <Box sx={{ position: 'absolute', width: '400px', height: '400px', background: 'rgba(36, 11, 54, 0.6)', borderRadius: '50%', filter: 'blur(100px)', bottom: '10%', right: '10%' }} />
            </Box>

            {/* Right Section: Glassmorphism Login */}
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3, background: '#fdfdfd' }}>
                <Box className="glass-panel entrance-delay" sx={{ width: '100%', maxWidth: 480, background: '#fff !important', boxShadow: '0 20px 60px rgba(0,0,0,0.1) !important' }}>
                <Button onClick={() => navigate("/")} sx={{mb: 2,color: "#4f378b",textTransform: "none",fontWeight: 600 }} >  ← Back to Home </Button>
                    <Typography variant="h4" sx={{ fontWeight: 800, fontFamily: 'Righteous', color: '#2b1055', mb: 1 }}>Sign In</Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>Welcome back! Please enter your details.</Typography>

                    <form onSubmit={handleSubmit}>
                        <TextField
                            label="Email"
                            name="email"
                            fullWidth
                            margin="normal"
                            variant="filled"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            sx={{ '& .MuiFilledInput-root': { borderRadius: '12px', backgroundColor: '#f0f0f7' } }}
                        />
                        <TextField
                            label="Password"
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            fullWidth
                            margin="normal"
                            variant="filled"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            sx={{ '& .MuiFilledInput-root': { borderRadius: '12px', backgroundColor: '#f0f0f7' }, mt: 2 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={togglePasswordVisibility}><VisibilityIcon /></IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button onClick={reset} sx={{ textTransform: 'none', color: '#4f378b', fontWeight: 600 }}>Forgot Password?</Button>
                        </Box>

                        <Button 
                            type="submit" 
                            fullWidth 
                            variant="contained" 
                            sx={{ mt: 4, py: 1.8, borderRadius: '12px', background: 'linear-gradient(90deg, #4f378b, #2b1055)', fontWeight: 700, textTransform: 'none', fontSize: '1rem', boxShadow: '0 10px 20px rgba(79, 55, 139, 0.3)' }}
                        >
                            {/* Login to Dashboard */}
                               {loading ? (
                                        <CircularProgress size={24} sx={{ color: "#fff" }} />
                                    ) : (
                                        "Login to Dashboard"
                                    )}
                        </Button>

                        {/* <Box sx={{ mt: 3, position: 'relative', textAlign: 'center' }}>
                            <Typography variant="caption" sx={{ background: '#fff', px: 2, position: 'relative', zIndex: 1, color: 'text.disabled' }}>OR CONTINUE WITH</Typography>
                            <Box sx={{ position: 'absolute', top: '50%', left: 0, right: 0, height: '1px', background: '#eee' }} />
                        </Box>

                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                            <GoogleLogin
                                clientId="320668170244-e1pjdbp6jpbutb6vppmr32tvna8t74ak.apps.googleusercontent.com"
                                buttonText="Google"
                                onSuccess={responseGoogle}
                                onFailure={onFailure}
                                className="google-login-btn"
                                style={{ width: '100%', borderRadius: '12px' }}
                            />
                        </Box> */}
                    </form>

                    <Typography sx={{ mt: 4, textAlign: 'center', color: 'text.secondary' }}>
                       Want to be part of us?<Button onClick={handleSignup} sx={{ color: "#4f378b", fontWeight: 800, textTransform: 'none' }}>Create Account</Button>
                    </Typography>
                </Box>
            </Box>

            <Dialog open={openDialog} onClose={handleCloseDialog} PaperProps={{ sx: { borderRadius: '20px', p: 2 } }}>
                <DialogContent><Typography>{dialogMessage}</Typography></DialogContent>
            </Dialog>

            <Dialog
    open={mfaOpen}
    onClose={closeMfa}
    PaperProps={{ sx: { borderRadius: '20px', p: 2, width: '100%', maxWidth: 420 } }}
>
    <DialogContent>
        <Typography variant="h5" sx={{ fontWeight: 800, fontFamily: 'Righteous', color: '#2b1055', mb: 1 }}>
            Two-Step Verification
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
            {useBackupCode
                ? "Enter one of your saved backup codes."
                : "Enter the 6-digit code from your authenticator app."}
        </Typography>

        <form onSubmit={submitMfaCode}>
            <TextField
                autoFocus
                fullWidth
                variant="filled"
                value={mfaCode}
                onChange={(e) => setMfaCode(
                    useBackupCode
                        ? e.target.value.toUpperCase()
                        : e.target.value.replace(/\D/g, "").slice(0, 6)
                )}
                error={Boolean(mfaError)}
                helperText={mfaError || " "}
                placeholder={useBackupCode ? "XXXXX-XXXXX" : "000000"}
                inputProps={{
                    inputMode: useBackupCode ? "text" : "numeric",
                    autoComplete: "one-time-code",
                    style: { letterSpacing: useBackupCode ? '2px' : '8px', fontSize: '1.3rem', textAlign: 'center' },
                }}
                sx={{ '& .MuiFilledInput-root': { borderRadius: '12px', backgroundColor: '#f0f0f7' } }}
            />

            <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={mfaLoading || !mfaCode.trim()}
                sx={{ mt: 2, py: 1.6, borderRadius: '12px', background: 'linear-gradient(90deg, #4f378b, #2b1055)', fontWeight: 700, textTransform: 'none', fontSize: '1rem' }}
            >
                {mfaLoading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Verify"}
            </Button>
        </form>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
                onClick={() => { setUseBackupCode(!useBackupCode); setMfaCode(""); setMfaError(""); }}
                sx={{ textTransform: 'none', color: '#4f378b', fontWeight: 600 }}
            >
                {useBackupCode ? "Use authenticator code" : "Use a backup code"}
            </Button>
            <Button onClick={closeMfa} sx={{ textTransform: 'none', color: 'text.secondary' }}>
                Cancel
            </Button>
        </Box>
    </DialogContent>
</Dialog>

        </Box>
    );
}

export default Login;